import { useInferableTranslation } from '@di-shared/features/common/useInferableTranslation';
import useCcWebviewUtilsHelper from '@di-shared/features/common/useCcWebviewUtilsHelper';
import { useEnvironmentStore } from '@di-shared/features/environment/environmentStore';
import { RegionType } from '@shared/cci/features/const/environment';

interface ExecuteFunction {
  (...args: any[]): any | Promise<any>;
}

export enum ErrorCode {}

export const CLIENT_ERROR_CODE = '9999';

export default function useApiError() {
  const {t} = useInferableTranslation();
  const {region} = useEnvironmentStore(({region}) => ({region}));
  const {openAlert} = useCcWebviewUtilsHelper();

  function getErrorCode(error: unknown) {
    // @ts-ignore
    return error?.code || error?.result_code || error?.resultCode || error?.status || CLIENT_ERROR_CODE;
  }

  async function resolveErrorKr(error: unknown): Promise<[execute: ExecuteFunction, code: number]> {
    const code = getErrorCode(error);

    switch (code) {
      default:
        return [
          () => {
            openAlert({title: t('T20096'), message: `error [${code}]`});
          },
          code,
        ];
    }
  }

  async function resolveErrorEu(error: unknown): Promise<[execute: ExecuteFunction, code: number]> {
    const code = getErrorCode(error);

    switch (code) {
      default:
        return [
          () => {
            openAlert({title: t('msg_error_title'), message: `${t('msg_error_title_01')}\nerror [${code}]`});
          },
          code,
        ];
    }
  }

  return {
    getErrorCode,
    resolveError(error: unknown) {
      return region === RegionType.KR ? resolveErrorKr(error) : resolveErrorEu(error);
    },
  };
}

// FIXME usage -- 봤으면 지울것
// function Some() {
//   const {resolveError} = useApiError();
//   const [someCall] = usePendingHandler(
//     async () => {
//       // do api
//     },
//     async (error) => {
//       const [execute, code] = await resolveError(error);
//       if (code === ErrorCode.SOME_FAIL) {
//         // 커스텀 니즈가 있는경우
//         execute('vin');
//       } else if (code === ErrorCode.ANOTHER_FAIL) {
//         // 커스텀 니즈가 있는경우
//         const isConfirm = await execute();
//         alert(isConfirm);
//       } else {
//         // 보통은 execute 만 하면 됨
//         execute();
//       }
//     }
//   );
//
//   someCall();
// }
